module.exports = __webpack_public_path__ + "img/conroy.df091e06.jpg";